import { AxiosResponse } from 'axios';

import axios from 'utils/axios';
import { IPage } from 'utils/itineraryDetails/types';

import { getAccountId } from './auth';

type CreateContentPageResponse = {
  data: IPage;
};

/**
 * Makes a POST request to create a new content page.
 */
export const postContentPage = async (
  formValues: Record<string, any>,
  currentStep: 'details' | 'page',
): Promise<CreateContentPageResponse> => {
  const response = (await axios.post(`/acc/${getAccountId()}/pages`, {
    ...formValues,
    currentStep,
  })) as AxiosResponse<CreateContentPageResponse>;

  return response.data;
};

/**
 * Updates an existing content page by making a PATCH.
 */
export const patchContentPage = async (
  pageId: string | number,
  formValues: Record<string, any>,
  currentStep: 'details' | 'page',
): Promise<CreateContentPageResponse> => {
  const response = (await axios.patch(`/acc/${getAccountId()}/pages/${pageId}`, {
    ...formValues,
    currentStep,
  })) as AxiosResponse<CreateContentPageResponse>;

  return response.data;
};
